import type { TRuleWithTheme } from 'styles/theme';
import type { TextFieldProps } from '../types';

type StyleProps = Pick<TextFieldProps, 'type'>;

export const formItem: TRuleWithTheme<StyleProps> = () => ({});
